import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { GraduationCap, Award, Users, BookOpenCheck } from "lucide-react";
import "../../../assests/css/students/Principal/PrincipalHero.css";

/**
 * PrincipalHero
 * -------------
 * Hero section for a school Principal's welcome page.
 * Built with React-Bootstrap's grid system (Container / Row / Col).
 *
 * EDIT THESE VALUES to match your Principal's real info:
 */
const principalData = {
  eyebrow: "Meet our Honourable Principal ",
  headline: ["Leading With", "Purpose & Vision"],
  name: "Dr. Lubna Akhlaq Khan",
  designation: "Principal",
  bio:
    "It is my pleasure to welcome you to our college. We believe that every student is special, talented, and capable of achieving great things. Our aim is not only to provide quality education but also to create a caring and supportive environment where students feel confident to learn, grow, and follow their dreams.",
  photo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjj-YhY08FXOCULQHiss3gD2X0qdDZF5hbzfRWGNrYPagkxNFVcNmTOK95&s=10",
  credentials: [
    { icon: GraduationCap, label: "PhD in English" },
    { icon: Award, label: "20 Years Experience" },
    { icon: Users, label: "Community Leader" },
    { icon: BookOpenCheck, label: "Academic Excellence" },
  ],
};

export default function PrincipalHero() {
  return (
    <section className="principal-hero">
      <Container>
        <Row className="align-items-center gy-5">
          {/* LEFT: Text content */}
          <Col xs={12} lg={6} className="hero-text-col">
            <p className="hero-eyebrow">{principalData.eyebrow}</p>

            <h1 className="hero-headline">
              {principalData.headline.map((line, i) => (
                <span className="headline-line" key={i}>
                  {line}
                </span>
              ))}
            </h1>

            <div className="hero-identity">
              <h2 className="hero-name">{principalData.name}</h2>
              <p className="hero-designation">{principalData.designation}</p>
            </div>

            <p className="hero-bio">{principalData.bio}</p>

            {/* <div className="hero-cta-group">
              <Button className="btn-primary-custom">Read Message</Button>
              <Button className="btn-outline-custom">View Achievements</Button>
            </div> */}
          </Col>

          {/* RIGHT: Photo with orbiting credential badges */}
          <Col xs={12} lg={6} className="hero-photo-col">
            <div className="photo-orbit-wrap">
              {/* Decorative dashed orbit ring (signature element) */}
              <svg className="orbit-ring" viewBox="0 0 520 520">
                <circle
                  cx="260"
                  cy="260"
                  r="248"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeDasharray="6 10"
                />
              </svg>

              <div className="photo-frame">
                <img
                  src={principalData.photo}
                  alt={principalData.name}
                  className="principal-photo"
                />
              </div>

              {/* Credential chips positioned around the orbit */}
              {principalData.credentials.map((cred, index) => {
                const Icon = cred.icon;
                return (
                  <div className={`orbit-chip chip-${index}`} key={index}>
                    <span className="chip-icon">
                      <Icon size={16} strokeWidth={2.2} />
                    </span>
                    <span className="chip-label">{cred.label}</span>
                  </div>
                );
              })}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}